import { IconCancelRegular, IconEyeRegular, IconProcessLoadingRegular, Tag } from '@telefonica/mistica';
import { BillsMonthType } from '../../../models/Bills.interfaces';
import { billsChartSize } from './constants/bills';
import { t } from 'i18next';
import { formatMobileNumber } from '../../../utils/dataTransformation/unitsConversion';

export const billsCharsOrganize = (data: BillsMonthType[]) => {
    const billsDivided = [];

    for (let i = 0; i < data.length; i += billsChartSize) {
        billsDivided.push(data.slice(i, i + billsChartSize));
    }

    return billsDivided;
};

export const handleDownloadFile = (blob: Blob, name: string, downloadRef: React.RefObject<HTMLAnchorElement>) => {
    if (downloadRef.current) {
        downloadRef.current.id = `${t('bills02')}${name}`;
        downloadRef.current.download = `${t('bills02')}${name}.pdf`;
        downloadRef.current.href = URL.createObjectURL(blob);
        downloadRef.current.click();
    }
};

export const handleParseBlob = (file: string, name: string, downloadRef: React.RefObject<HTMLAnchorElement>) => {
    let blob = new Blob([file], { type: 'application/pdf' });

    handleDownloadFile(blob, name, downloadRef);
};

export const getIcon = (conceptType: string, iconsMap: Record<string, JSX.Element>, phone: string) => {
    if (conceptType === 'Llamada') {
        const isLandline = isLandlinePhoneNumber(phone);
        return isLandline ? iconsMap['Llamada'] : iconsMap['Mensaje'];
    }
    return iconsMap[conceptType];
};

export const setTypeTagstatus = (status: any) => {
    switch (status) {
        case 'Abierto':
            return (
                <Tag Icon={IconProcessLoadingRegular} type='success'>
                    {t('billsTagOpen')}
                </Tag>
            );
        case 'En curso':
            return (
                <Tag Icon={IconEyeRegular} type='warning'>
                    {t('billsTagInProgress')}
                </Tag>
            );
        case 'Pendiente de conformidad':
            return (
                <Tag Icon={IconEyeRegular} type='success'>
                    {t('billsTagPending')}
                </Tag>
            );
        case 'Pendiente de cierre':
            return (
                <Tag Icon={IconEyeRegular} type='success'>
                    {t('billsTagPendingPendingClose')}
                </Tag>
            );
        case 'Cerrado':
            return (
                <Tag Icon={IconCancelRegular} type='inactive'>
                    {t('billsTagClose')}
                </Tag>
            );
        default:
            return null;
    }
};

export const isLandlinePhoneNumber = (phone: string): boolean => {
    const normalized = phone.replace(/\D/g, '');
    return /^([89]\d{8})$/.test(normalized);
};

export const getConsumptionName = (claim: any) => {
    switch (claim.typeDescription) {
        case 'Mensaje':
            return `${t('sms')} - ${formatMobileNumber(
                claim.appliedCustomerBillingRateCharDTOOUTs.find((item: any) => item.name === 'CalledPhone')?.value,
            )}`;
        case 'Llamada':
            return `${formatMobileNumber(
                claim.appliedCustomerBillingRateCharDTOOUTs.find((item: any) => item.name === 'CalledPhone')?.value,
            )}`;
        case 'Internet':
            return formatMobileNumber(claim.product.identification);
        default:
            return t('extraContent');
    }
};

export const getUnits = (claim: any) => {
    if (claim.typeDescription === 'Llamada') {
        const totalSeconds =
            Number(claim.appliedCustomerBillingRateCharDTOOUTs.find((item: any) => item.name === 'Duration')?.value) ||
            0;
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        let result = '';
        if (hours > 0) result += `${hours} h `;
        if (minutes > 0) result += `${minutes} m `;
        if (seconds > 0 || (!hours && !minutes)) result += `${seconds} s`;
        return result.trim();
    }
    if (claim.typeDescription === 'Internet') {
        const kb =
            Number(claim.appliedCustomerBillingRateCharDTOOUTs.find((item: any) => item.name === 'Duration')?.value) ||
            0;
        if (kb >= 1024 * 1024) {
            // GB
            const gb = kb / (1024 * 1024);
            return `${gb.toFixed(gb < 10 ? 2 : 1)} GB`;
        }
        if (kb >= 1024) {
            // MB
            const mb = kb / 1024;
            return `${mb.toFixed(mb < 10 ? 2 : 1)} MB`;
        }
        return `${kb} KB`;
    }
    return '';
};
